import Vue from "vue";
import Component from "vue-class-component";
import useUserTags from "@/hooks/useUserTags";

type HookType = ReturnType<typeof useUserTags>;
@Component({
  name: "WithUserTags",
  setup() {
    const { userTagsUpdateData, userTagsGetData } = useUserTags();
    return { userTagsUpdateData, userTagsGetData };
  },
})
export default class WithUserTags extends Vue {
  public userTagsUpdateData!: HookType["userTagsUpdateData"];
  public userTagsGetData!: HookType["userTagsGetData"];
}
